export enum CreateDestinationStepPaths {
  SELECT_DESTINATION_TYPE = 'add-destination/select-destination-type',
  DESTINATION_CONNECTION_SETTINGS = 'add-destination/connection-settings'
}
